

export enum DateGroupType {
	FirstRecord = 1,
	AdditionalSection = 2
}